module.exports = __webpack_public_path__ + "static/media/09.151fbfb5.png";